export default "https://storage.googleapis.com/prepweb-prod/dist/739e8105a2663a81a7b1f19026d47119.svg";